import React from "react";

function StatCard({ label, value, accent, className = "" }) {
  return (
    <div className={`stat-card stat-card-${accent || "blue"} ${className}`.trim()}>
      <p className="stat-label">{label}</p>
      <h3 className="stat-value">{value}</h3>
    </div>
  );
}

export default StatCard;
